import React from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import './PublicLayout.css';

const PublicLayout = () => {
  const navigate = useNavigate();

  return (
    <div className="public-layout">
      <nav className="public-navbar">
        <div className="navbar-container">
          <div className="navbar-brand">
            <Link to="/">
              <h1>⚖️ e-Court Management System</h1>
            </Link>
          </div>
          <ul className="navbar-menu">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/courts">Courts</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
            <li><Link to="/case-status" className="nav-link-special">Case Status</Link></li>
            <li>
              <button onClick={() => navigate('/login')} className="btn-login">
                Login
              </button>
            </li>
          </ul>
        </div>
      </nav>

      <main className="public-content">
        <Outlet />
      </main>

      <footer className="public-footer">
        <div className="footer-container">
          <div className="footer-section">
            <h3>⚖️ e-Court Management System</h3>
            <p>Streamlining court operations and case management for the digital age.</p>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/courts">Courts</Link></li>
              <li><Link to="/case-status">Case Status</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contact</h4>
            <p>Email: info@ecourt.gov</p>
            <p>Phone: +1 (555) 123-4567</p>
            <p>Address: 123 Justice Street, Legal City</p>
          </div>
          <div className="footer-section">
            <h4>Follow Us</h4>
            <div className="social-links">
              <a href="#" aria-label="Facebook">📘</a>
              <a href="#" aria-label="Twitter">🐦</a>
              <a href="#" aria-label="LinkedIn">💼</a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 e-Court Management System. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default PublicLayout;

